import React, {Component} from "react";
import {I18n} from "../../../I18n/components/player";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {SUPER_ADMIN, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import PlayerFolderList from "./PlayerFolderList";
import PlayerFolderModal from "./PlayerFolderModal";
import playerValidator from "../../../helpers/playerValidator";
import CommonValidator from "../../../helpers/CommonValidator";
import {
    fetchPlayerFolders,
    removePlayerFolder,
    saveNewPlayerFolder,
    updateSinglePlayerFolder
} from "../../../actions/player/playerFolderActions";
import DeleteModal from "../../Common/Modal/DeleteModal";
import PlayerFolderControls from "./PlayerFolderControls";
import swal from "sweetalert";
import {fetchTinyStores, fetchTinyStoresWithOperator} from "../../../actions/storesActions";
import {isPlayerPermission} from "../../../helpers/companyService";

class PlayerFolder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeFolderId: null,
            newFolder: {
                id: null,
                name: '',
                companyId: null,
                salesPointIds: [],
                shared: false,
            },
            companyIdFilter: '',
            currentPage: 0,
            modal: false,
            isSaveDisable: false,
        };
        this.validators = playerValidator(props.lang).folderValidator;
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority, location} = this.props;

            if (!isPlayerPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            await this.clearNewFolderState();
            await this.fetchPaginatedData(0);
            if (location.state && location.state.modal) {
                await this.toggle();
            }
            await Promise.all(this.getAdditionalDataFetches());
        })();
    }

    isConflictError = response => response && response.status === 409;

    fetchPaginatedData = async currentPage => {
        const {company, authority} = this.props;
        const {companyIdFilter} = this.state;
        await this.props.fetchFolders({
            companyId: authority === SUPER_ADMIN ? companyIdFilter : company.id,
            page: currentPage
        });
        await this.setState({
            currentPage
        });
    };

    getAdditionalDataFetches = () => {
        const {authority, company} = this.props;
        if (authority === SUPER_ADMIN) {
            return [
                this.props.fetchTinyStores()
            ];
        } else if (company.types.includes('RETAIL')) {
            return [
                this.props.fetchTinyStores({companyIds: [company.id]})
            ];
        } else if (company.types.includes('OPERATOR')) {
            return [
                this.props.fetchTinyStoresWithOperator(company.id)
            ];
        }
    }

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    toggle = async () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    isOkModalToggle = id => {
        this.setState({
            isOkModal: !this.state.isOkModal,
            activeFolderId: id
        });
    };

    onCompanyFilterClick = event => {
        this.setState({
            companyIdFilter: event.target.value
        }, async () => {
            await this.fetchPaginatedData(0);
        });
    }

    clearFilters = () => {
        this.setState({
            companyIdFilter: '',
        }, async () => {
            await this.fetchPaginatedData(0);
        })
    };

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value;
        this.commonValidator.checkField(name, value);
        this.setState(state => ({
            newFolder: Object.keys(state.newFolder).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.newFolder[key];
                }
                return res
            }, {})
        }));
    };

    onStoresChange = stores => {
        const allOptions = stores.find(option => Array.isArray(option.value));
        const storeIds = allOptions
            ? allOptions.value
            : stores.map(sp => sp.value);
        this.setState({
            newFolder: {
                ...this.state.newFolder,
                salesPointIds: storeIds
            },
        });
    }

    clearNewFolderState = async () => {
        const {company, authority} = this.props;
        this.commonValidator.resetAllErrors();
        await this.setState({
            newFolder: {
                id: null,
                name: '',
                companyId: authority !== SUPER_ADMIN ? company.id : null,
                shared: this.isFoldersSharedByDefault()
            },
            activeFolderId: null,
        });
    };

    isFoldersSharedByDefault = () => {
        const {company, authority} = this.props;
        return authority === SUPER_ADMIN
            ? false
            : company.types.includes('OPERATOR')
    }

    addFolderClick = async () => {
        await this.clearNewFolderState();
        await this.toggle();
    };

    onEditFolder = async (id) => {
        await this.clearNewFolderState();
        let selectedFolder = this.props.playerFolders
            .find(item => item.id === id);
        this.setState({
            modal: !this.state.modal,
            newFolder: selectedFolder,
        });
    };

    deleteFolder = async () => {
        await this.props.deleteFolder(this.state.activeFolderId);
        await this.fetchPaginatedData(0);
        this.setState({
            activeFolderId: null
        }, () => this.isOkModalToggle(null))
    };

    handleSubmit = async (event) => {
        const {newFolder} = this.state;
        const {lang, playerFolders} = this.props;
        if (event) {
            event.preventDefault();
        }
        let folders = playerFolders || [];
        if (this.commonValidator.isValid()) {
            await this.setState({isSaveDisable: true});
            const folderExists = folders.filter(folder => folder.id === newFolder.id)
                .length > 0;
            const promise = folderExists
                ? this.props.updateFolder(newFolder)
                : this.props.saveFolder(newFolder);
            promise.then(async () => {
                await this.fetchPaginatedData(0);
                await this.clearNewFolderState();
                await this.toggle();
            }).catch(error => {
                if (this.isConflictError(error)) {
                    swal(I18n[lang].folderAlreadyExists, "", "error")
                }
                console.log(error.statusText);
            })
            await this.setState({isSaveDisable: false});
        }
    };

    render() {
        const {
            lang,
            authority,
            loading,
            companies,
            company,
            tinyStores,
            tinyStoresWithOperator,
            playerFolders,
            pagination
        } = this.props;
        const {currentPage, isOkModal, newFolder, companyIdFilter, modal} = this.state;

        const stores = tinyStores.concat(tinyStoresWithOperator);

        const playerFolderList = loading
            ? <div className="loading">Loading...</div>
            : <PlayerFolderList
                lang={lang}
                companies={companies}
                folders={playerFolders}
                currentPage={currentPage}
                onEditFolder={this.onEditFolder}
                isOkModalToggle={this.isOkModalToggle}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
            />

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <DeleteModal
                    lang={lang}
                    isOkModal={isOkModal}
                    toggle={this.isOkModalToggle}
                    onDeleteClick={this.deleteFolder}
                />
                <PlayerFolderModal
                    lang={lang}
                    isModal={modal}
                    toggle={this.toggle}
                    newFolder={newFolder}
                    companies={companies}
                    stores={stores}
                    handleSubmit={this.handleSubmit}
                    onInputChange={this.onInputChange}
                    onStoresChange={this.onStoresChange}
                    validator={this.commonValidator}
                    isSaveDisable={this.state.isSaveDisable}
                    showSharedCheckbox={authority === SUPER_ADMIN || company.types.includes('OPERATOR')}
                    authority={authority}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-play-circle-outline mr-2"/>
                            {I18n[lang].player + ' / ' + I18n[lang].folders}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <PlayerFolderControls
                            lang={lang}
                            onCompanyFilterClick={this.onCompanyFilterClick}
                            authority={authority}
                            companies={companies}
                            companyId={companyIdFilter}
                            clearFilters={this.clearFilters}
                            addFolderClick={this.addFolderClick}
                        />
                        {playerFolderList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchFolders: query => dispatch(fetchPlayerFolders(query)),
        saveFolder: folder => dispatch(saveNewPlayerFolder(folder)),
        updateFolder: folder => dispatch(updateSinglePlayerFolder(folder)),
        deleteFolder: folderId => dispatch(removePlayerFolder(folderId)),
        fetchTinyStores: query => dispatch(fetchTinyStores(query)),
        fetchTinyStoresWithOperator: (operatorCompanyId) => dispatch(fetchTinyStoresWithOperator(operatorCompanyId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    playerFolders: state.playerFolders.playerFolders,
    pagination: state.playerFolders.pagination,
    loading: state.playerFolders.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    tinyStores: state.tinyStoresReducer.tinyStores,
    tinyStoresWithOperator: state.tinyStoresWithOperatorReducer.tinyStoresWithOperator,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayerFolder)


// WEBPACK FOOTER //
// ./src/components/Player/PlayerFolder/PlayerFolder.js